import styles from './RelatedPost.module.scss'
import NextLink from 'next/link'
import NextImage from 'next/image'
import imageService from '@/modules/imageService'

interface RelatedPostProps {
  id: string
  title: string
  slug: string
  image: string | null
  createdBy: string
}

function RelatedPost ({ id, title, slug, image, createdBy }: RelatedPostProps) {
  // limit the number of characters in the title - replace the rest with '...'
  const charLength = 65
  if (title.length > charLength) {
    title = title.substring(0, charLength) + '...'
  }
  return (
    <div className={styles.wrapper}>
      <NextLink
        href={`/${slug}`}
      >
        <div className={styles.recordImageWrapper}>
          {image &&
            <NextImage
              src={imageService.postImageURL(id, image)}
              alt="placeholder"
              width={200}
              height={200}
              className={styles.recordImage}
            />
          }
          {!image &&
            <imageService.Placeholder
              width={200}
              height={200}
              className={styles.recordImage}
            />
          }
        </div>
        <div className={styles.overlay}>
          <div className={styles.upper}>
            @{createdBy}
          </div>
          <div className={styles.title}>{title}</div>
        </div>
      </NextLink>
    </div>
  )
}

export default RelatedPost
